import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Modal from 'components/Modal';
import WoffEmbeddedIcon from 'components/WoffEmbeddedIcon';

export default createReactClass({
  propTypes: {
    kitToken: PropTypes.string.isRequired,
    workingSetIcon: ImmutablePropTypes.record.isRequired,
    show: PropTypes.bool.isRequired,
    onRemovedIcon: PropTypes.func.isRequired,
    onClosed: PropTypes.func.isRequired,
  },

  mixins: [ImmutableRenderMixin],

  handleConfirmation(event) {
    event.preventDefault();
    event.stopPropagation();

    this.props.onRemovedIcon(this.props.workingSetIcon);
  },

  handleClosed(event) {
    if (event) event.preventDefault();

    this.props.onClosed();
  },

  render() {
    return (
      <Modal contentLabel="Remove icon" isOpen={this.props.show} onRequestClose={this.handleClosed}>
        <div className="modal-content" role="document">
          <div className="modal-header bg-danger dashed dashed-bottom m-xs-b-xs p-xs-b-sm">
            <button type="button" className="close close-dangle" onClick={this.handleClosed}>
              <span aria-hidden="true">
                <i className="ficon ficon-times"></i>
              </span>
            </button>
            <h3 className="modal-title">
              <i className="ficon ficon-warning m-xs-r-md"></i>
              Delete {this.props.workingSetIcon.name}?
            </h3>
          </div>
          <div className="modal-body">
            <div className="text-lg well bg-body">
              Are you sure you would like to permanently delete this icon? This action cannot be undone.
            </div>

            <table className="table text-xl">
              <tbody>
                <tr>
                  <th scope="row" className="text-base text-normal text-muted valign-middle">
                    Icon
                  </th>
                  <td className="text-strong p-xs-r-2x valign-middle">
                    <WoffEmbeddedIcon woff={this.props.workingSetIcon.woff} />
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="text-base text-normal text-muted valign-middle">
                    Name
                  </th>
                  <td className="text-strong p-xs-r-2x valign-middle">
                    {this.props.workingSetIcon.name}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="modal-footer bg-body">
            <a href="#" className="btn btn-lg btn-secondary" onClick={this.handleClosed}>Cancel</a>
            <a href="#" className="btn btn-lg btn-danger" rel="nofollow" onClick={this.handleConfirmation}>
              Yes, Delete
              <i className="ficon ficon-trash m-xs-l-md"></i>
            </a>
          </div>
        </div>
      </Modal>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/RemoveIconModal.js